exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#member-activity-table tr,td,th{border-color:#000!important}#member-activity-table td,th{padding:0 16px;border-width:0}#member-activity-table tr:hover{background-color:inherit}@media print{.pagebreak{page-break-after:always;min-height:1px}body,html{font-size:10pt;margin-top:-40px}}", ""]);

// exports
